import {useLanguage} from "../context/LanguageContext";
import {translations} from "../utils/translations";
import {LanguageSelector} from "../components/LanguageSelector";
import {Header} from "../components/Header";
import {HeroSection} from "../components/HeroSection";
import {Footer} from "../components/Footer";
import React from "react";
import {Section} from "../components/Section";

export function TermsOfServicePage() {

    const {lang} = useLanguage();
    const t = translations[lang];

    const TermsComponent = ({t}: any) => {
        return (
            <Section>
                <h1>{t.terms.title}</h1>
                <p>{t.terms.description}</p>
            </Section>
        )
    }

    return (
        <main className="static-page">
            <LanguageSelector/>
            <Header t={t} isBackButtonVisible={true}/>
            <HeroSection t={t}/>
            <TermsComponent t={t}/>
            <Footer t={t}/>
        </main>
    );
}